import { render, staticRenderFns } from "./X-statut-modale-livraison.vue?vue&type=template&id=7138cbba"
import script from "./X-statut-modale-livraison.vue?vue&type=script&lang=js"
export * from "./X-statut-modale-livraison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7138cbba')) {
      api.createRecord('7138cbba', component.options)
    } else {
      api.reload('7138cbba', component.options)
    }
    module.hot.accept("./X-statut-modale-livraison.vue?vue&type=template&id=7138cbba", function () {
      api.rerender('7138cbba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/X-statut-modale-livraison.vue"
export default component.exports